import Swiper, { Navigation } from "swiper";
import axios from 'axios';

export const initDealerUsedVehicles = () => {
    const dealerUsedVehicles = document.querySelectorAll('.cms-content-slice-dealer-used-vehicle');
    const dealerUsedVehiclesLength = dealerUsedVehicles.length;
    if (dealerUsedVehiclesLength <= 0) {
        return;
    }
    for (let index = 0; index < dealerUsedVehiclesLength; index++) {
        const slider = dealerUsedVehicles[index].querySelector('.swiper');
        if (slider) {
            new Swiper(slider, {
                modules: [Navigation],
                grabCursor: true,
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                navigation: {
                    nextEl: '.cms-content-slice-dealer-used-vehicle__slider-nav--next',
                    prevEl: '.cms-content-slice-dealer-used-vehicle__slider-nav--prev',
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                    },
                    768: {
                        slidesPerView: 3,
                    },
                }
            });
        }
    }
}

export const initDealerMap = () => {
    const dealerMapObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                window.GoogleMapsLoader.getMap().then((google) => {
                    const mapEl = entry.target.querySelector('.cms-content-slice-dealership-map__map');
                    const mapData = JSON.parse(mapEl.dataset.map);
                    const mapLatLng = new google.maps.LatLng(mapData.lat, mapData.lng);
                    const mapOptions = {
                        center: mapLatLng,
                        zoom: 15,
                        disableDefaultUI: true,
                    };
                    const mapInstance = new google.maps.Map(mapEl, mapOptions);

                    const marker = new google.maps.Marker({
                        position: mapLatLng,
                        map: mapInstance,
                        title: mapData.title,
                    });
                });

                observer.unobserve(entry.target);
            }
        });
    });

    const dealerMap = document.querySelectorAll('.cms-content-slice-dealership-map__grid');
    const dealerMapLength = dealerMap.length;
    if (dealerMapLength > 0) {
        for (let index = 0; index < dealerMapLength; index++) {
            dealerMapObserver.observe(dealerMap[index]);
        }
    }
}

export const initDealerContactForms = () => {
    const dealerContactForms = document.querySelectorAll('.cms-content-slice-dealer-contact-form');
    const dealerContactFormsLength = dealerContactForms.length;
    if (dealerContactFormsLength == 0) {
        return;
    }
    for (let index = 0; index < dealerContactFormsLength; index++) {
        const dealerLocatorContactContainer = dealerContactForms[index];
        const dealerLocatorContactForm = dealerLocatorContactContainer.querySelector('form');
        const contactValidator = new ContactFormValidator({
            element: dealerLocatorContactForm,
            redesign: true,
        });
        dealerLocatorContactForm.addEventListener('submit', function(e) {
            e.preventDefault();
            if (!contactValidator.isValid()) {
                return false;
            }

            const formData = new FormData(dealerLocatorContactForm);
            contactValidator.preventInput();
            // const submitButton = form.querySelector('button[type="submit"]');


            // formSuccess.innerHTML = `<div class="loading-icon__container">
            //     <img src="/images/shared/Robins-And-Day-Loader-Purple.svg" class="loading-icon__icon" alt="Loading" />
            // </div>`

            axios.post(dealerLocatorContactForm.action, formData)
            .then(function(response) {
                if (response.data.id) {
                    contactValidator.allowInput();
                    dealerLocatorContactContainer.innerHTML = `<div class="cms-content-slice-dealer-contact-form__success">
                        <h2 class="cms-content-heading">Thank you for your enquiry</h2>
                        <p>
                            We have sent your details to ${response.data.name}. A member of the team will be in contact with you shortly to discuss your enquiry.
                        </p>
                    </div>`;
                } else {
                    contactValidator.errorResponse(response);
                }
            }).catch(function(error) {
                console.error(error);
                contactValidator.errorResponse(error);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/cms-content-slices/modules/dealers.js